import { render, staticRenderFns } from "./VeeRule.vue?vue&type=template&id=0131d12a&scoped=true&"
import script from "./VeeRule.vue?vue&type=script&lang=js&"
export * from "./VeeRule.vue?vue&type=script&lang=js&"
import style0 from "./VeeRule.vue?vue&type=style&index=0&id=0131d12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131d12a",
  null
  
)

export default component.exports